export default __webpack_public_path__ + "static/media/portfolio-44.84ab3832.jpg";